import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🙋", key: "justMe" },
  { emoji: "👨‍👩‍👧", key: "myFamily" },
  { emoji: "🥂", key: "guests" },
  { emoji: "🏷️", key: "forSale" },
]

export default function HomeShareWithWhoPage() {
  return (
    <RadioCardListPage translationKey="homeShareWithWho" options={OPTIONS} />
  )
}
